/**
 * getCurrentBuildId function
 * Returns the unique id of the build currently running in this tab. Reads the
 * BUILD_ID compile-time constant, guarding against environments (e.g. tests)
 * where it is not substituted.
 *
 * @returns The current build id, or an empty string when unavailable
 */
export const getCurrentBuildId = (): string => (typeof BUILD_ID === "undefined" ? "" : BUILD_ID);
